import { $modalOpen } from './stores.js';
import { closeModalEv, openModalEv } from './events.js';

$modalOpen.on(openModalEv, () => true).reset(closeModalEv);
